import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["r", "fill", "clip-path"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  class: "camera-marker__main-circle",
  cx: "50%",
  cy: "50%",
  r: "15"
}, null, -1)
const _hoisted_4 = ["d"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  class: "camera-marker__blank-circle",
  cx: "50%",
  cy: "50%",
  r: "10"
}, null, -1)
const _hoisted_6 = {
  key: 2,
  class: "camera-marker__recording-circle",
  cx: "50%",
  cy: "50%",
  r: "2"
}
const _hoisted_7 = ["data-id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["stop-color"]
const _hoisted_10 = ["stop-color"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LIcon = _resolveComponent("LIcon")!
  const _component_LMarker = _resolveComponent("LMarker")!

  return (_openBlock(), _createBlock(_component_LMarker, {
    "lat-lng": _ctx.latLng,
    onMouseover: _cache[0] || (_cache[0] = (e) => _ctx.showPopup(e.originalEvent.target)),
    onMouseout: _ctx.hidePopup
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LIcon, {
        iconSize: [_ctx.CMR, _ctx.CMR],
        "class-name": "camera-marker__icon-wrapper"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("svg", {
            style: _normalizeStyle([{"pointer-events":"none"}, _ctx.iconSvgStyle]),
            class: _normalizeClass(_ctx.iconClass),
            width: _ctx.size,
            height: _ctx.size,
            viewBox: `0 0 ${_ctx.size} ${_ctx.size}`,
            fill: "none"
          }, [
            (_ctx.hasCone)
              ? (_openBlock(), _createElementBlock("circle", {
                  key: 0,
                  r: _ctx.fullRadius,
                  cx: "50%",
                  cy: "50%",
                  fill: `url(#${_ctx.gradientId})`,
                  "clip-path": `url(#${_ctx.gradientClipPathId})`
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _hoisted_3,
            (_ctx.showStatus)
              ? (_openBlock(), _createElementBlock("path", {
                  key: 1,
                  d: _ctx.statusPath,
                  class: _normalizeClass([`camera-marker__status`, `camera-marker__status_${this.streamStatus}`])
                }, null, 10, _hoisted_4))
              : _createCommentVNode("", true),
            _hoisted_5,
            _createElementVNode("circle", {
              class: _normalizeClass(_ctx.openedCircleClass),
              cx: "50%",
              cy: "50%",
              r: "10"
            }, null, 2),
            (_ctx.item.active && _ctx.item.stream_settings.enable_recorder)
              ? (_openBlock(), _createElementBlock("circle", _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("circle", {
              class: "camera-marker__transparent-circle",
              cx: "50%",
              cy: "50%",
              r: "15",
              "data-id": _ctx.clickTargetDataId
            }, null, 8, _hoisted_7),
            _createElementVNode("defs", null, [
              _createElementVNode("radialGradient", { id: _ctx.gradientId }, [
                _createElementVNode("stop", {
                  offset: "0%",
                  "stop-color": _ctx.coneGradientColor
                }, null, 8, _hoisted_9),
                _createElementVNode("stop", {
                  offset: "100%",
                  "stop-opacity": "0",
                  "stop-color": _ctx.coneGradientColor
                }, null, 8, _hoisted_10)
              ], 8, _hoisted_8),
              _createElementVNode("clipPath", { id: _ctx.gradientClipPathId }, [
                (_ctx.hasCone)
                  ? (_openBlock(), _createElementBlock("path", {
                      key: 0,
                      d: _ctx.conePath,
                      fill: "white"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_11)
            ])
          ], 14, _hoisted_1))
        ]),
        _: 1
      }, 8, ["iconSize"])
    ]),
    _: 1
  }, 8, ["lat-lng", "onMouseout"]))
}